import getBibTeXJSON from './json';
import { plugins } from '@citation-js/core';
var syntaxTokens = {
  '|': '{\\textbar}',
  '<': '{\\textless}',
  '>': '{\\textgreater}',
  '~': '{\\textasciitilde}',
  '^': '{\\textasciicircum}',
  '\\': '{\\textbackslash}',
  '{': '\\{\\vphantom{\\}}',
  '}': '\\vphantom{\\{}\\}'
};

function escapeValue(value) {
  return value.replace(/[|<>~^\\{}]/g, function (match) {
    return syntaxTokens[match];
  });
}

var richTextMappings = {
  i: '\\textit{',
  b: '\\textbf{',
  sc: '\\textsc{',
  sup: '\\textsuperscript{',
  sub: '\\textsubscript{',
  'span style="font-variant:small-caps;"': '\\textsc{',
  'span class="nocase"': '{'
};

function serializeRichTextValue(value) {
  var closingTags = [];
  var tokens = value.split(/<(\/?(?:i|b|sc|sup|sub|span)|span .*?)>/g);
  tokens = tokens.map(function (token, index) {
    if (index % 2 === 0) {
      return escapeValue(token);
    } else if (token in richTextMappings) {
      closingTags.push('/' + token.split(' ')[0]);
      return richTextMappings[token];
    } else if (token === closingTags[closingTags.length - 1]) {
      closingTags.pop();
      return '}';
    } else {
      return '';
    }
  });
  return tokens.join('');
}

var richTextFields = ['title'];

function serializeValue(prop, value, dict) {
  if (richTextFields.includes(prop)) {
    value = serializeRichTextValue(value);
  } else {
    value = escapeValue(value);
  }

  return dict.listItem.join("".concat(prop, " = {").concat(value, "},"));
}

function serializeEntry(entry, dict, opts) {
  var _getBibTeXJSON = getBibTeXJSON(entry, opts),
      type = _getBibTeXJSON.type,
      label = _getBibTeXJSON.label,
      properties = _getBibTeXJSON.properties;

  properties = Object.keys(properties).map(function (prop) {
    return serializeValue(prop, properties[prop], dict);
  }).join('');
  return dict.entry.join("@".concat(type, "{").concat(label, ",").concat(dict.list.join(properties), "}"));
}

var getBibtex = function getBibtex(src, dict, opts) {
  var entries = src.map(function (entry) {
    return serializeEntry(entry, dict, opts);
  }).join('');
  return dict.bibliographyContainer.join(entries);
};

var getBibTeXWrapper = function getBibTeXWrapper(src, html) {
  var dict = plugins.dict.get(html ? 'html' : 'text');
  return getBibtex(src, dict);
};

export { getBibtex };
export default getBibTeXWrapper;